'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scheduleContext = exports.viewingNextCycle = exports.userId = exports.userHasCpCorporateEmail = exports.memberStatus = exports.isLoggedIn = undefined;

var _deep = require('helpers/deep');

var isLoggedIn = exports.isLoggedIn = function isLoggedIn(state) {
  return !!state.user.loggedIn;
};

var memberStatus = exports.memberStatus = function memberStatus(state) {
  return state.user.loggedIn && state.entities.userProfile.data.default ? state.entities.userProfile.data.default.membership.status : '';
};

var userHasCpCorporateEmail = exports.userHasCpCorporateEmail = function userHasCpCorporateEmail(state) {
  return (0, _deep.deepExtract)('default.email', state.entities.userProfile.data, '').indexOf('@classpass.com') !== -1;
};

var userId = exports.userId = function userId(state) {
  return state.user.loggedIn && state.entities.userProfile.data.default ? state.entities.userProfile.data.default.id : null;
};

var viewingNextCycle = exports.viewingNextCycle = function viewingNextCycle(state) {
  return state.user.viewingNextCycle;
};
var scheduleContext = exports.scheduleContext = function scheduleContext(state) {
  return state.user.scheduleContext;
};